import { DevicePid } from '@/define/define'

export const adjustableKeys = (device: number): number[] => {
  if (DevicePid.IrokFe87V2IMC == device || DevicePid.IrokFe87V2IMC_24g == device) {
    return [0x22, 0x31, 0x32, 0x33, 0x50, 0x40, 0x53]
  }
  return []
}
